"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Actions_1 = require("../Actions");
var Client = /** @class */ (function () {
    function Client(_a) {
        var _this = this;
        var channelName = _a.channelName, _b = _a.postElement, postElement = _b === void 0 ? window.parent : _b, _c = _a.listenElement, listenElement = _c === void 0 ? window : _c;
        this.eventMap = {};
        this.getCallbacksForAction = function (action) {
            return _this.eventMap[action] === undefined ? [] : _this.eventMap[action];
        };
        this.listener = function (_a) {
            var data = _a.data;
            if (data &&
                Object.keys(Actions_1.default).indexOf(data.action) !== -1 &&
                data.payload &&
                _this.channelName === data.channelName) {
                _this.getCallbacksForAction(data.action).forEach(function (callback) {
                    return callback(data.payload);
                });
            }
        };
        this.channelName = channelName;
        this.postElement = postElement;
        this.listenElement = listenElement;
        this.listenElement.addEventListener('message', this.listener);
    }
    Client.prototype.unsubscribe = function () {
        this.listenElement.removeEventListener('message', this.listener);
    };
    Client.prototype.on = function (action, listener) {
        this.eventMap[action] = __spreadArrays(this.getCallbacksForAction(action), [listener]);
    };
    Client.prototype.off = function (action, listener) {
        this.eventMap[action] = this.getCallbacksForAction(action).filter(function (callback) { return callback !== listener; });
    };
    Client.prototype.removeAllListeners = function () {
        this.eventMap = {};
    };
    Client.prototype.postMessage = function (action, data) {
        this.postElement.postMessage({ action: action, payload: data, channelName: this.channelName }, '*');
    };
    return Client;
}());
exports.default = Client;
//# sourceMappingURL=Client.js.map